// extracted by mini-css-extract-plugin
export default {"universe":"style_universe__nZssA","earth":"style_earth__4NVKA","moon":"style_moon__v5PnH","moon-invert":"style_moon-invert__nxp8v"};